import SystemScreenInfoTitleText from "../texts/SystemScreenInfoTitleText";
import SystemScreenInfoSubtitleText from "../texts/SystemScreenInfoSubtitleText";
import SystemScreenErrorIcon from "../icons/SystemScreenErrorIcon";
import {SystemPrimaryCustomButton} from "../buttons/SystemCustomButton";
import {kSystemTexts} from "../../constants/texts";
import {kButtonStyles} from "../../constants/styles";
import {useNavigate} from "react-router-dom";
import {internalRoutes} from "../../constants/internalRoutes";

export default function SystemFullScreenError({error, extraClass}) {
    // Used through the app to display an error object made of
    // error icon, title (problem) and subtitle (reinsurance)

    // PROPERTIES
    const navigate = useNavigate();

    // BUILD
    return (
        <div className={"animate-appear bg-backgroundLight3 w-full h-[100svh] flex flex-col justify-center items-center space-y-[6px] " + extraClass}>
            <div className={"w-[344px] flex flex-col justify-start items-center space-y-[6px]"}>
                <SystemScreenErrorIcon />
                <SystemScreenInfoTitleText title={error.statement} />
                <SystemScreenInfoSubtitleText subtitle={error.reassurance} />
            </div>
            <SystemPrimaryCustomButton
                label={kSystemTexts.home}
                isDisabled={false}
                isLoading={false}
                isFullWidth={false}
                sizeStyle={kButtonStyles.mediumButtonStyle}
                onButtonClick={() => navigate(internalRoutes.home)}
                extraClass={"mt-[16px]"} />
        </div>
    );
}